import { render, staticRenderFns } from "./FamilyMessageHistoryDetail.vue?vue&type=template&id=2ed2431e&lang=pug"
import script from "./FamilyMessageHistoryDetail.vue?vue&type=script&lang=ts"
export * from "./FamilyMessageHistoryDetail.vue?vue&type=script&lang=ts"
import style0 from "./FamilyMessageHistoryDetail.vue?vue&type=style&index=0&id=2ed2431e&prod&lang=scss&scopeed=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports